export default __webpack_public_path__ + "cf43a081a334491d0d1c02a2ad79e72b.png";